
import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from "react";
import { faAddressBook, faIdCard, faPhone, faFile, faBuilding, faUser } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Form, Card, Button, Badge, Container, InputGroup } from '@themesberg/react-bootstrap';

import api from "../../api/axios";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useHistory } from "react-router-dom";
import { addMember, dashboardUserFiles } from "../../api/services";
import Preloader from "../../components/Preloader"; // Path to your code above
// import { useHistory } from "react-router-dom";
import { faHips } from "@fortawesome/free-brands-svg-icons";
import { Routes } from "../../routes";

export default () => {
  const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [dob, setDob] = useState();
  const [dlNumber, setDlNumber] = useState("");
  const [dlFile, setDlFile] = useState(null);
  const [altphoneNumber, setAltPhoneNumber] = useState("");
  const [dlIssueDate, setDlIssueDate] = useState();
  const [dlExpiryDate, setDlExpiryDate] = useState();
  const [address, setAddress] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    // setShowLoader(true);
    setSuccess("");
    setError("");

    try {
      const payload = {
        firstName: firstName,
        lastName: lastName,
        phone: phoneNumber,
        altphone: altphoneNumber,
        role: "DRIVER",
        permissions: [202],
        dlNum: dlNumber,
        dlIssueDate,
        dlExpiryDate,
        dob,
        address,
        isActive: true
      };

      console.log("Form submitted with data:", payload);

      const resp = await addMember(payload);

      const uploadResp = await dashboardUserFiles(null, 103);
      console.log("File upload response:", uploadResp);
      setShowLoader(true);
      console.log("Profile update response:", resp);
      setSuccess("Driver added successfully!");
      await delay(5000); // Waits for 2 seconds
      history.push(Routes.Team_Driver.path);
    } catch (error) {
      console.log("Form submission error:", error.response?.data || error.message);
      setShowLoader(false);
      // ✅ Better error handling
      setError(
        error.response.data.error || "Something went wrong!"
      );
    } finally {
      setShowLoader(false);
    }
  };

  const getMaxDOB = () => {
    const today = new Date();
    today.setFullYear(today.getFullYear() - 18);
    return today.toISOString().split("T")[0];
  };

  return (
    <main>
      <Preloader show={showLoader} />

      <Container className="px-0" style={{ backgroundColor: `#ffffff` }}>
        <section className="d-flex align-items-center my-5 mt-lg-2 mb-lg-2" >
          <Container>
            {/* <div className="d-flex justify-content-center align-items-center mt-4">
            </div> */}
            {error && (<div class="alert alert-danger">
              {error}
            </div>)}

            {
              success && (<div class="alert alert-success">
                {success}
              </div>)
            }
            <Row className="justify-content-center form-bg-image">
              <Col lg={12} /*className="d-flex align-items-center justify-content-center"*/>
                <Form className="mt-0" onSubmit={handleSubmit}>
                  <Form.Group id="first-name" className="mb-2">
                    <Form.Label>First Name</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUser} />
                      </InputGroup.Text>
                      <Form.Control
                        autoFocus
                        required
                        type="tel"
                        placeholder="First Name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                    </InputGroup>
                  </Form.Group>

                  <Form.Group id="last-name" className="mb-2">
                    <Form.Label>Last Name</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUser} />
                      </InputGroup.Text>
                      <Form.Control
                        autoFocus
                        required
                        type="tel"
                        placeholder="Last Name"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                      />
                    </InputGroup>
                  </Form.Group>

                  <Form.Group id="dob" className="mb-2">
                    <Form.Label>Date of Birth</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>📅</InputGroup.Text>
                      <Form.Control
                        required
                        type="date"
                        value={dob}
                        onChange={(e) => setDob(e.target.value)}
                        // max={new Date().toISOString().split("T")[0]} // prevents future dates
                        max={getMaxDOB()}
                      />
                    </InputGroup>
                  </Form.Group>

                  <Form.Group id="phone" className="mb-2">
                    <Form.Label>Phone Number</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faPhone} />
                      </InputGroup.Text>
                      <Form.Control
                        autoFocus
                        required
                        type="tel"
                        placeholder="Phone Number"
                        value={phoneNumber}
                        minLength={10}
                        maxLength={10}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Allow only digits (0-9)
                          if (/^\d*$/.test(value)) {
                            setPhoneNumber(value);
                          }
                        }}
                        isInvalid={phoneNumber && phoneNumber.length !== 10}
                      />
                    </InputGroup>
                  </Form.Group>

                  <Form.Group id="alt-phone" className="mb-2">
                    <Form.Label>Alternate Phone Number (Optional)</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faPhone} />
                      </InputGroup.Text>
                      <Form.Control
                        autoFocus
                        type="tel"
                        placeholder="Alternate Phone Number"
                        value={altphoneNumber}
                        minLength={10}
                        maxLength={10}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Allow only digits (0-9)
                          if (/^\d*$/.test(value)) {
                            setAltPhoneNumber(value);
                          }
                        }}
                        isInvalid={altphoneNumber && altphoneNumber.length !== 10}
                      />
                    </InputGroup>
                  </Form.Group>

                  <Form.Group id="dl-number" className="mb-2">
                    <Form.Label>DL Number</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faIdCard} />
                      </InputGroup.Text>
                      <Form.Control
                        autoFocus
                        required
                        type="text"
                        placeholder="DL Number"
                        minLength={16}
                        maxLength={16}
                        value={dlNumber}
                        onChange={(e) => setDlNumber(e.target.value)}
                      />
                    </InputGroup>
                  </Form.Group>

                  {/* <Row className="py-2 border-bottom m-0">
                    <Col md={6} style={{ borderRight: "1px solid #ddd", fontWeight: "600", background: "#fafafa" }}>
                      GST Document
                    </Col>
                    <Col md={6}>
                      {gstFilePreview ? (
                        <a href={gstFilePreview} target="_blank" rel="noopener noreferrer">
                          📄 View GST PDF
                        </a>
                      ) : "-"}
                    </Col>
                  </Row> */}
                  
                  <Form.Group id="dl-issue-date" className="mb-2">
                  <Form.Label>Upload DL (in PDF format)</Form.Label>
                  <Form.Control
                    type="file"
                    accept=".pdf"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        if (file.type !== "application/pdf") {
                          alert("Only PDF files are allowed");
                          e.target.value = null; // reset input
                          return;
                        }
                        setDlFile(file);

                        const fileURL = URL.createObjectURL(file);
                        // setGstFilePreview(fileURL);

                      }
                    }}
                  />
                  </Form.Group>

                  <Form.Group id="dl-issue-date" className="mb-2">
                    <Form.Label>DL Issue Date</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>📅</InputGroup.Text>
                      <Form.Control
                        required
                        type="date"
                        value={dlIssueDate}
                        onChange={(e) => setDlIssueDate(e.target.value)}
                        max={new Date().toISOString().split("T")[0]} // prevents future dates
                      />
                    </InputGroup>
                  </Form.Group>

                  <Form.Group id="dl-Expiry-date" className="mb-2">
                    <Form.Label>DL Expiry Date</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>📅</InputGroup.Text>
                      <Form.Control
                        required
                        type="date"
                        value={dlExpiryDate}
                        onChange={(e) => setDlExpiryDate(e.target.value)}
                      // max={new Date().toISOString().split("T")[0]} // prevents future dates
                      />
                    </InputGroup>
                  </Form.Group>

                  <Form.Group id="address" className="mb-2">
                    <Form.Label>Address</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faAddressBook} />
                      </InputGroup.Text>
                      <Form.Control
                        autoFocus
                        required
                        type="text"
                        placeholder="Address"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </InputGroup>
                  </Form.Group>

                  <Button variant="primary" type="submit" className="w-100">
                    Add Driver
                  </Button>
                </Form>
                <div className="d-flex justify-content-center align-items-center mt-4">
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Container>


    </main>
  );
};
